import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

const STORAGE_KEY = "fk-cookie-consent";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = window.localStorage.getItem(STORAGE_KEY);
      if (!v) {
        const id = setTimeout(() => setVisible(true), 900);
        return () => clearTimeout(id);
      }
    } catch (_e) {
      setVisible(true);
    }
  }, []);

  const accept = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (_e) {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  const c = t.cookies;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label={c.title}
      className="fixed bottom-3 left-3 right-3 sm:left-5 sm:right-auto sm:max-w-md z-[55] fk-glass rounded-2xl border border-[#FF5A00]/25 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.7)] p-4 sm:p-5 animate-[fk-fade-up_500ms_cubic-bezier(0.2,0.8,0.2,1)_both]"
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 w-9 h-9 rounded-xl bg-[#FF5A00]/12 border border-[#FF5A00]/25 inline-flex items-center justify-center text-[#FF5A00] shrink-0">
          <i className="fa-solid fa-cookie-bite text-sm" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-white">{c.title}</div>
          <p className="mt-1 text-xs sm:text-[13px] text-zinc-400 leading-relaxed">
            {c.body}{" "}
            <Link
              to="/privacy-policy"
              data-testid="cookie-banner-policy-link"
              className="text-[#FF5A00] hover:underline"
            >
              {c.learnMore}
            </Link>
          </p>
          <div className="mt-3 flex items-center gap-2">
            <button
              data-testid="cookie-banner-accept"
              onClick={() => accept("accepted")}
              className="fk-btn fk-btn-primary !py-1.5 !px-4 !text-xs"
            >
              {c.accept}
            </button>
            <button
              data-testid="cookie-banner-dismiss"
              onClick={() => accept("dismissed")}
              className="text-xs text-zinc-400 hover:text-white px-3 py-1.5 transition-colors"
            >
              {c.dismiss}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
